import { render } from "./Event-Detail.vue?vue&type=template&id=96d299a0"
import script from "./Event-Detail.vue?vue&type=script&lang=js"
export * from "./Event-Detail.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/d/git/workshop/social-friendsquads/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__